import {
  CREATE_LEAGUE_LOADING,
  CREATE_LEAGUE_SUCCESS,
  CREATE_LEAGUE_ERROR,
  SEASONS_LIST_LOADING,
  SEASONS_LIST_ERROR,
  SEASONS_LIST_SUCCESS,
  LIST_LEAGUES_LOADING,
  LIST_LEAGUES_ERROR,
  LIST_LEAGUES_SUCCESS,
  ADD_POINT_SYSTEM_LOADING,
  LIST_POINT_SYSTEM_LOADING,
  LIST_POINT_SYSTEM_ERROR,
  LIST_POINT_SYSTEM_SUCCESS,
  ADD_POINT_SYSTEM_ERROR,
  ADD_POINT_SYSTEM_SUCCESS,
  UPDATE_POINT_SYSTEM_LOADING,
  UPDATE_POINT_SYSTEM_ERROR,
  UPDATE_POINT_SYSTEM_SUCCESS,
  EDIT_LEAGUE_LOADING,
  EDIT_LEAGUE_ERROR,
  EDIT_LEAGUE_SUCCESS,
  DELETE_LEAGUE_LOADING,
  DELETE_LEAGUE_ERROR,
  DELETE_LEAGUE_SUCCESS,
  CLEAR_DELETE_LEAGUE,
  CLEAR_CREATE_LEAGUE,
  CLEAR_EDIT_LEAGUE,
} from "../../../constant/actionTypes";

import { BASE_URL } from "../../../constant/apiURL";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiDelete, apiGet, apiPost, apiPut } from "../../../utils/apiRequests";

export const createLegue = (data) => (dispatch) => {
  dispatch({ type: CREATE_LEAGUE_LOADING });

  apiPut(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.add}`,
    data,
    (response) => {
      if (response.error == true) {
        dispatch({ type: CREATE_LEAGUE_ERROR, response: response.message });
      } else {
        dispatch({ type: CREATE_LEAGUE_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: CREATE_LEAGUE_ERROR, response: error });
    }
  );
};

export const editLeague = (data, leagueId) => (dispatch) => {
  dispatch({ type: EDIT_LEAGUE_LOADING });

  apiPut(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.update}/${leagueId}`,
    data,
    (response) => {
      if (response.error == true) {
        dispatch({ type: EDIT_LEAGUE_ERROR, response: response.message });
      } else {
        dispatch({ type: EDIT_LEAGUE_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: EDIT_LEAGUE_ERROR, response: error });
    }
  );
};

export const deleteLeague = (leagueId) => (dispatch) => {
  dispatch({ type: DELETE_LEAGUE_LOADING });

  apiDelete(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.delete}/${leagueId}`,
    (response) => {
      if (response.error == true) {
        dispatch({ type: DELETE_LEAGUE_ERROR, response: response.message });
      } else {
        dispatch({ type: DELETE_LEAGUE_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: DELETE_LEAGUE_ERROR, response: error });
    }
  );
};

export const clearDeleteLeague = () => (dispatch) => {
  dispatch({
    type: CLEAR_DELETE_LEAGUE,
  });
};

export const clearCreateLeague = () => (dispatch) => {
  dispatch({
    type: CLEAR_CREATE_LEAGUE,
  });
};

export const clearEditLeague = () => (dispatch) => {
  dispatch({
    type: CLEAR_EDIT_LEAGUE,
  });
};

export const getSeasons = () => (dispatch) => {
  dispatch({ type: SEASONS_LIST_LOADING });
  apiGet(
    ApiEndpoints.season.base,
    (response) => {
      if (response.error == true) {
        dispatch({ type: SEASONS_LIST_ERROR, response: response.message });
      } else {
        dispatch({ type: SEASONS_LIST_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: SEASONS_LIST_ERROR, response: error });
    }
  );
};

export const listAllLeague = () => (dispatch) => {
  dispatch({ type: LIST_LEAGUES_LOADING });

  apiGet(
    ApiEndpoints.league.base,
    (response) => {
      if (response.error == true) {
        dispatch({ type: LIST_LEAGUES_ERROR, response: response.message });
      } else {
        dispatch({ type: LIST_LEAGUES_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: LIST_LEAGUES_ERROR, response: error });
    }
  );
};

export const listAllPointSystem = () => (dispatch) => {
  dispatch({ type: LIST_POINT_SYSTEM_LOADING });

  apiGet(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.pointSystem}`,
    (response) => {
      if (response.error == true) {
        dispatch({ type: LIST_POINT_SYSTEM_ERROR, response: response.message });
      } else {
        dispatch({ type: LIST_POINT_SYSTEM_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: LIST_LEAGUES_ERROR, response: error });
    }
  );
};

//  save a point system

export const addPointSystemAction = (data) => (dispatch) => {
  dispatch({ type: ADD_POINT_SYSTEM_LOADING });

  apiPut(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.pointSystem}`,
    data,
    (response) => {
      if (response.error == true) {
        dispatch({ type: ADD_POINT_SYSTEM_ERROR, response: response.message });
      } else {
        dispatch({ type: ADD_POINT_SYSTEM_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: ADD_POINT_SYSTEM_ERROR, response: error });
    }
  );
};

export const updatePointSystemAction = (data, psID) => (dispatch) => {
  // psID => POINT SYSTEM ID
  dispatch({ type: UPDATE_POINT_SYSTEM_LOADING });

  apiPut(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.pointSystemUpdate}/${psID}`,
    data,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: UPDATE_POINT_SYSTEM_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: UPDATE_POINT_SYSTEM_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: UPDATE_POINT_SYSTEM_ERROR, response: error });
    }
  );
};
